import Button from "components/Button";
import Form from "components/Form";
import Label from "components/Label";
import React, { FC } from "react";
import segment from "lib/segment";

import { SharedFlowState } from "components/Flow/types";
import { useRecoilState } from "recoil";
import VendorAuditIcon from "../../../../../../public/onboarding-clipboard-icon.svg";
import VendorManagementIcon from "../../../../../../public/onboarding-van-icon.svg";
import RenovationsIcon from "../../../../../../public/onboarding-drill-icon.svg";
import DailyMaintenanceIcon from "../../../../../../public/onboarding-paint-roller-icon.svg";

import styles from "./styles.module.scss";

type Props = {
  sharedFlowState: SharedFlowState;
  nextStep(): void;
};

type FormValues = {
  projects?: string[];
};

const Services: FC<Props> = ({ sharedFlowState, nextStep }) => {
  const [state, setState] = useRecoilState(sharedFlowState);

  return (
    <div className={styles.container}>
      <Label className={styles.title} variant="centered-h4" color="primary2">
        What kinds of projects can we do for you?
      </Label>
      <Label
        className={styles.subtitle}
        variant="body-centered"
        color="primary2"
      >
        We can take care of all home maintenance needs — from proactive to
        reactive to seasonal maintenance. Some homeowners have a project
        in-mind, others don&apos;t. We&apos;re here to support you in all
        aspects of home management any way!
      </Label>
      <Form
        className={styles.form}
        fields={[
          {
            type: "icon_select",
            id: "projects",
            options: [
              {
                value: "Renovations",
                label: "Renovations",
                Icon: RenovationsIcon
              },
              {
                value: "Daily maintenance",
                label: "Daily maintenance",
                Icon: DailyMaintenanceIcon
              },
              {
                value: "Vendor management",
                label: "Vendor management",
                Icon: VendorManagementIcon
              },
              {
                value: "Vendor audir",
                label: "Vendor audit",
                Icon: VendorAuditIcon
              }
            ]
          }
        ]}
        onSubmit={(values: FormValues) => {
          segment.track("LeadFlowServicesSubmitted", values);
          setState({ ...state, ...values });
          nextStep();
        }}
      >
        {() => (
          <Button type="submit" className={styles.submit} variant="accent">
            Continue
          </Button>
        )}
      </Form>
    </div>
  );
};

export default Services;
